import { DsIconButton, DsMenu, DsMenuItem, DsMenuTrigger, useScreenSize } from '@frontends/ds';
import 'flag-icons/css/flag-icons.min.css';
import { LOCALES, useLocale } from '@frontends/util-i18n';
import { useTranslation } from 'react-i18next';
import { useEntityConfig } from '@/hooks/useEntityConfig';

export function LanguageSelector() {
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();
  const config = useEntityConfig();

  // The context is the only source of truth: LocaleProvider applies the choice to
  // i18next and the document, and preferences persist it.
  const { locale, setLocale } = useLocale();

  const label = t('language');
  const locales = LOCALES.filter((option) => config.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES.includes(option.language));

  return (
    <DsMenuTrigger placement="bottom end">
      <DsIconButton name="globe" aria-label={label} tooltip={label} />

      <DsMenu
        size={isMobile ? 'touch' : 'default'}
        selectionMode="single"
        selectedKeys={[locale.language]}
        onAction={(key) => {
          const next = locales.find((option) => option.language === key);

          if (next) {
            setLocale(next);
          }
        }}
      >
        {locales.map((option) => (
          <DsMenuItem key={option.language} id={option.language} textValue={option.name}>
            <span className="flex items-center gap-2">
              <span aria-hidden className={`fi fi-${option.country.toLowerCase()} shrink-0`} />
              {option.name}
            </span>
          </DsMenuItem>
        ))}
      </DsMenu>
    </DsMenuTrigger>
  );
}
